import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import { motion } from 'framer-motion';

const QRCodeGenerator = ({ url, albumTitle, onClose }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current && url) {
      QRCode.toCanvas(canvasRef.current, url, {
        width: 256,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });
    }
  }, [url]);

  const handleDownload = () => {
    if (canvasRef.current) {
      const link = document.createElement('a');
      link.download = `${albumTitle}-qr-code.png`;
      link.href = canvasRef.current.toDataURL();
      link.click();
    }
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const canvas = canvasRef.current;
    
    if (canvas && printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>QR Code - ${albumTitle}</title>
            <style>
              body { 
                font-family: 'Inter', sans-serif; 
                text-align: center; 
                padding: 40px;
                background: white;
              }
              .qr-container { 
                display: inline-block; 
                padding: 30px; 
                border: 1px solid #e5e5e5; 
                border-radius: 8px;
                background: white;
              }
              h1 { 
                color: #000; 
                margin-bottom: 20px; 
                font-weight: 300;
                font-size: 24px;
              }
              p { 
                color: #666; 
                margin-top: 15px;
                font-weight: 300;
              }
            </style>
          </head>
          <body>
            <div class="qr-container">
              <h1>${albumTitle}</h1>
              <img src="${canvas.toDataURL()}" alt="QR Code" />
              <p>Scan to view and upload photos</p>
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="bg-white rounded-lg max-w-md w-full p-8"
      >
        <div className="text-center">
          <h2 className="text-2xl font-light text-black mb-6">QR Code</h2>
          <p className="text-gray-600 font-light mb-6">{albumTitle}</p>
          
          <div className="bg-gray-50 p-8 rounded-lg mb-6 inline-block">
            <canvas ref={canvasRef} className="block mx-auto"></canvas>
          </div>

          <p className="text-gray-600 text-sm mb-8 font-light leading-relaxed">
            Guests can scan this QR code with their phone camera to instantly access your album and upload photos.
          </p>

          <div className="flex space-x-3">
            <button
              onClick={handleDownload}
              className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium transition-all btn-secondary"
            >
              Download
            </button>
            <button
              onClick={handlePrint}
              className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium transition-all btn-secondary"
            >
              Print
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-3 bg-black text-white rounded-md hover:bg-gray-800 font-medium transition-all btn-primary"
            >
              Close
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default QRCodeGenerator;